import { RootStore } from '@my/mobx-rootstore';

export const rootStore = new RootStore();

export default rootStore;
